// src/utils/ticketUtils.js
export const canAccessTicket = (ticket, user, selectedQueueIds) => {
  const { profile, queues } = user;
  const ticketQueueId = ticket.queueId;

  // 1. Admin vê tudo
  if (profile === "admin") return true;

  // 2. Se não tem fila, só admin pode ver
  if (!ticketQueueId) return false;

  // 3. Verifica se o usuário tem acesso à fila
  return selectedQueueIds.includes(ticketQueueId);
};